<form [formGroup]="searchForm" (submit)="onSubmit()" class="search-form">
  <mat-form-field class="tl-filter-field tl-filter-field--fluid">
    <mat-icon matPrefix>search</mat-icon>

    <input type="text" matInput [placeholder]="placeholder" formControlName="search" />

    <mat-icon matSuffix (click)="onReset()" [ngClass]="canReset ? 'opacity-100' : 'opacity-0'"
      >close</mat-icon
    >
  </mat-form-field>
</form>
